import axios from 'axios'
import store from './store/store';
import { refreshToken } from './axiosRequests'
import router from './router'
import { isRefusal } from './httpRefusal'

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT

// axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters['auth/getMyToken']

// TEST-ONLY silent token renewal (see src/silentTokenRenewal.js). The flag is set in
// .env.test only; without it this is null, the module is not bundled, and every
// interceptor below runs exactly as before.
const silentRenewal = process.env.VUE_APP_SILENT_TOKEN_RENEWAL === 'on'
  // getStore/refreshToken are lazy: this file is first evaluated while store/store.js is
  // still evaluating (import cycle), so `store` is undefined here; axiosRequests imports this file.
  ? require('./silentTokenRenewal').default({ getStore: () => store, refreshToken: t => refreshToken(t) })
  : null

const attachAuthAndTrack = response => {
  if (
    store.getters['auth/getMyToken'] && 
    store.getters['auth/getMyToken'] !== null && 
    store.getters['auth/getMyToken'] !== "null" &&
    response.url !== 'https://securetoken.googleapis.com/v1/token?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw' &&
    response.url !== 'https://identitytoolkit.googleapis.com/v1/accounts…sword?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw' &&
    response.url !== 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw' &&
    response.url !== 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw' &&
    response.url !== 'https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw' &&
    response.url !== '/v1/user/completeSignup'
  ) {
    response.headers.Authorization = 'Bearer ' + store.getters['auth/getMyToken']
  }
  if (response.url !== "https://securetoken.googleapis.com/v1/token?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw" && response.url !== '/v1/attachment/') {

    store.dispatch('addLastErrorEP', response.url)
    store.dispatch('addEPPayload', JSON.stringify(response.data))
    
    let datetime = new Date()
    let day = datetime.getDate(), month = datetime.getMonth()+1, year = datetime.getFullYear(), hour = datetime.getHours(), minute = datetime.getMinutes()
    if(day < 10)
    day = '0'+day
    if(month<10)
    month = '0'+month
    if(hour<10)
    hour = '0'+hour
    if(minute<10)
    minute = '0'+minute
    store.dispatch('addEPDatetime', `${day}/${month}/${year} ${hour}:${minute}:00`)


  }

  store.dispatch('addLastEP', {
    url: response.url,
    method: response.method,
    body: response.data
  })

  return response
}

axios.interceptors.request.use(
  silentRenewal
    ? config => silentRenewal.beforeRequest(config).then(attachAuthAndTrack)
    : attachAuthAndTrack
)

axios.interceptors.response.use(function (response) {

  store.dispatch('removeEP', {
    url: response.config.url,
    method: response.config.method,
    body: response.config.body
  })

  // Refreshing token after 5 mins (300000 ms)
  let a = new Date().getTime()
  if (response && store.getters['auth/getMyRefreshToken'] && store.getters['auth/getNextRefreshTime'] && a > store.getters['auth/getNextRefreshTime']) {
    
    refreshToken(store.getters['auth/getMyRefreshToken'])
      .then(data => {
        
        // 
        store.dispatch('auth/setMyToken', data.id_token)
        store.dispatch('auth/setMyRefreshToken', data.refresh_token)
        store.dispatch('auth/setNextRefreshTime', new Date().getTime() + 300000) // refresh token in 5 mins... also see in Login.vue response interceptor
      })
      .catch(err => {
        
        if (err.response && err.response !== 200) {
          store.dispatch('auth/setMyProfile', null)
          store.dispatch('auth/setMyToken', null)
          store.dispatch('auth/setMyRefreshToken', null)
          router.push('/login?logout=true')
        }
      })

  } else {
    
  }

  return response;

}, silentRenewal
  ? function (error) {
    const retried = silentRenewal.retryAfterRefresh(error, axios, handleResponseError)
    return retried || handleResponseError(error)
  }
  : handleResponseError
)

function handleResponseError (error) {

  if(store.getters.getLastErrorEP === error.config.url){
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
  
      store.dispatch('addEPError',JSON.stringify(error.response.data))
      store.dispatch('addErrorCode',error.response.status)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      store.dispatch('addEPError',JSON.stringify(error.request))
    } else {
      // Something happened in setting up the request that triggered an Error
      store.dispatch('addEPError',JSON.stringify(error.message))
    }
  } else {
    store.dispatch('addEPError',null)
    store.dispatch('addErrorCode',null)
  }

  if (
    error && 
    error.response
  ) {



    // a refusal (403 with a message for the user) is the calling screen's to show, not an expired session
    if (isRefusal(error.response)) {
      return Promise.reject(error)
    }
    if (
      error.response.status === 403 ||
      error.response.status === 401 ||
      error.response.data === 'request.getHeader("Authorization") must not be null'
    ) {
    
      store.dispatch('auth/setMyProfile', {})
      store.dispatch('auth/setMyToken', '')
      store.dispatch('auth/setMyRefreshToken', '')
      store.dispatch('auth/setNextRefreshTime', new Date().getTime())
      
      if (router && router.history && router.history.current && router.history.current.name !== 'mbpLogin') {
        // 
        // router.push({ name: 'mbpLogin' })
        store.dispatch('setReLoginDialog', true)
      }
    } else {
      store.dispatch('removeEP', {
        url: error.response.config.url,
        method: error.response.config.method,
        body: error.response.config.body
      })
  
    }
    return Promise.reject(error);
  } else {
    return Promise.reject()
  }

}

export default axios
